// Disbursements Page
export const DISBURSEMENTS_PAGE_TITLE = 'Disbursements';
export const DISBURSEMENTS_PAGE__EDIT_BUTTON = 'Edit Disbursement';
export const DISBURSEMENTS_PAGE__TABLE_HEADER__DISPLAY_ID = 'Disbursement ID';
export const DISBURSEMENTS_PAGE__TABLE_HEADER__AMOUNT = 'Amount';
export const DISBURSEMENTS_PAGE__TABLE_HEADER__STATUS = 'Status';
export const DISBURSEMENTS_PAGE__TABLE_HEADER__CREATED_DATE = 'Date Created';
export const DISBURSEMENTS_PAGE__ADD_DISBURSEMENT_BUTTON = 'Add Disbursement';

// Disbursement Page
export const DISBURSEMENT_PAGE__TITLE = 'Disbursement';
export const DISBURSEMENT_PAGE__AMOUNT_TITLE = 'Amount';
export const DISBURSEMENT_PAGE__POLICYHOLDER_TITLE = 'Policyholder';
export const DISBURSEMENT_PAGE__POLICY_TITLE = 'Policy';
export const DISBURSEMENT_PAGE__DATE_CREATED_TITLE = 'Date Created';
export const DISBURSEMENT_PAGE__DATE_UPDATED_TITLE = 'Last Modified';
export const DISBURSEMENT_PAGE__STATUS_TITLE = 'Status';
export const DISBURSEMENT_PAGE__DISBURSEMENT_NOT_FOUND =
	'Disbursement not found';
export const DISBURSEMENT_PAGE__DISBURSEMENT_NOT_FOUND_ACTION_TEXT = 'Go Back';

// Actions
export const DISBURSEMENT_PAGE__DISCARD_BUTTON = 'Discard Disbursement';
export const DISBURSEMENT_PAGE__EDIT_BUTTON = 'Edit Disbursement';
export const DISBURSEMENT_PAGE__SAVE_BUTTON = 'Save';
export const DISBURSEMENT_PAGE__ISSUE_BUTTON = 'Issue';
export const CREATE_DISBURSEMENT__SHORTCUT = 'Issue Disbursement';
export const DOWNLOAD_DISBURSEMENT_DOCUMENT = 'Download Disbursement';
export const COPY_DISBURSEMENT_LOCATOR = 'Copy Disbursement Locator';
export const COPY_DISBURSEMENT_LOCATOR__SUCCESS =
	'Disbursement locator copied to clipboard';

// Discard Modal
export const DISCARD_DISBURSEMENT_MODAL__BUTTON = 'Discard Disbursement';
export const DISCARD_DISBURSEMENT_MODAL__TITLE = 'Discard Disbursement';
export const DISCARD_DISBURSEMENT_MODAL__BODY_TEXT_TITLE =
	'Are you sure you want to discard this disbursement? This action cannot be undone.';
export const DISCARD_DISBURSEMENT_MODAL__SUBMIT = 'Discard';
export const DISCARD_DISBURSEMENT_MODAL__CANCEL = 'Cancel';

// Issue Modal
export const ISSUE_DISBURSEMENT_MODAL__BUTTON = 'Issue Disbursement';
export const ISSUE_DISBURSEMENT_MODAL__TITLE = 'Issue Disbursement';
export const ISSUE_DISBURSEMENT_MODAL__BODY_TEXT_TITLE =
	'Are you sure you want to issue this disbursement? This action cannot be undone.';
export const ISSUE_DISBURSEMENT_MODAL__SUBMIT = 'Issue';
export const ISSUE_DISBURSEMENT_MODAL__CANCEL = 'Cancel';

// Create Disbursement Page
export const CREATE_DISBURSEMENT_PAGE__TITLE = 'New Disbursement';
export const CREATE_DISBURSEMENT_PAGE__SUBMIT = 'Create';
export const CREATE_DISBURSEMENT_PAGE__CANCEL = 'Cancel';
export const CREATE_DISBURSEMENT_PAGE__READY_TO_POST_LABEL = 'Ready';

// Disbursement States
export const DISBURSEMENT_STATE_CHIP__DRAFT = 'Draft';
export const DISBURSEMENT_STATE_CHIP__ISSUED = 'Issued';
export const DISBURSEMENT_STATE_CHIP__DISCARDED = 'Discarded';
export const DISBURSEMENT_STATE_CHIP__ERROR = 'Status Not Found';

// Breadcrumbs
export const DISBURSEMENTS_BREADCRUMB = 'Disbursements';
export const DISBURSEMENTS_BREADCRUMB__EDIT = 'Edit';
export const DISBURSEMENTS_BREADCRUMB__NEW = 'New';
export const DISBURSEMENT_BREADCRUMB__DISPLAY_ID = (disbursementID: string) =>
	`Disbursement ${disbursementID}`;

// Disbursements Api
export const DISBURSEMENT_API_MUTATION__UPDATE_STATUS_ERROR_TOAST =
	'Error updating disbursement status: ';
export const DISBURSEMENT_API_MUTATION__STATUS_UPDATE_SUCCESS_TOAST =
	'Disbursement status updated successfully';
export const DISBURSEMENT_API_MUTATION__UPDATE_SUCCESS_TOAST =
	'Disbursement saved successfully';
export const DISBURSEMENT_API_MUTATION__UPDATE_ERROR_TOAST =
	'Error saving disbursement: ';
export const DISBURSEMENT_API_MUTATION__CREATE_SUCCESS_TOAST =
	'Disbursement created successfully';
export const DISBURSEMENT_API_MUTATION__CREATE_ERROR_TOAST =
	'Error creating disbursement: ';
export const DISBURSEMENT_API_MUTATION__ISSUE_SUCCESS_TOAST =
	'Disbursement issued successfully';
export const DISBURSEMENT_API_MUTATION__DISCARD_SUCCESS_TOAST =
	'Disbursement discarded successfully';
